import React, { useState } from 'react';

const ContactUs: React.FC = () => {
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setSubmitted(true);
    };

    return (
        <div style={{ padding: "2rem", maxWidth: 700, margin: "0 auto" }}>
            <h2 style={{ color: "#1976d2", fontSize: "2.1rem" }}>Contact Us</h2>
            {submitted ? (
                <div style={{ marginTop: "2rem", color: "#388e3c", fontWeight: "bold" }}>
                    Thank you for your message! We’ll get back to you soon.
                </div>
            ) : (
                <form
                    onSubmit={handleSubmit}
                    style={{
                        marginTop: "2rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.2rem"
                    }}
                >
                    <input
                        type="text"
                        name="name"
                        required
                        placeholder="Your Name"
                        style={{
                            padding: ".7rem 1rem",
                            borderRadius: "8px",
                            border: "1px solid #bbb",
                            fontSize: "1.05rem"
                        }}
                    />
                    <input
                        type="email"
                        name="email"
                        required
                        placeholder="Your Email"
                        style={{
                            padding: ".7rem 1rem",
                            borderRadius: "8px",
                            border: "1px solid #bbb",
                            fontSize: "1.05rem"
                        }}
                    />
                    <textarea
                        name="message"
                        required
                        placeholder="Your Message"
                        rows={5}
                        style={{
                            padding: ".9rem 1rem",
                            borderRadius: "8px",
                            border: "1px solid #bbb",
                            resize: "vertical",
                            fontSize: "1.05rem"
                        }}
                    />
                    <button
                        type="submit"
                        style={{
                            padding: ".75rem 1.7rem",
                            borderRadius: "8px",
                            background: "linear-gradient(90deg, #7b1fa2 20%, #1976d2 80%)",
                            color: "#fff",
                            fontWeight: "bold",
                            letterSpacing: "1px",
                            border: "none",
                            fontSize: "1.1rem",
                            cursor: "pointer"
                        }}
                    >
                        Send Message
                    </button>
                </form>
            )}
            <div style={{ marginTop: "2.5rem", fontSize: "1rem", color: "#333" }}>
                You can also email us directly at <a href="mailto:contact@algebracorp.com">contact@algebracorp.com</a>
            </div>
        </div>
    );
};

export default ContactUs;
